module.exports = __webpack_public_path__ + "img/42000.8adac4cd.jpg";